import { Vector3 } from 'three';

export class ArticleConstants {
  // TODO: (from flex) refactor this constant:
  public static readonly CONSTANT_POINT: Vector3 = new Vector3(10000, -8500, -9300);

  public static readonly BLOCKING_ZONE_TYPE_START: string = 'startBlockingZone';
  public static readonly BLOCKING_ZONE_TYPE_END: string = 'endBlockingZone';

  public static readonly DEFAULT_SPEEDWAY_ARTICLE_ID: number = 28524;
  public static readonly DEFAULT_FREE_MOUNTING_ARTICLE_ID: number = 28521;

  public static readonly BLOCKINGZONE_ARTICLE_NO: string = 'BlockingZone';
  public static readonly EMPTYZONE_ARTICLE_NO: string = 'EmptyZone';
  public static readonly CUSTOM_ARTICLE_NO: string = 'CustomArticle';
  public static readonly FREE_MOUNTING_ARTICLE_NO: string = 'FREE MOUNTING';
  public static readonly LTL_DEFAULT_BASEARTICLE_NO: string = '274-0099';

  public static readonly DEFAULT_TS_35_RAIL_ARTICLE_NO: string = '210-112';
  public static readonly DEFAULT_TS_15_RAIL_ARTICLE_NO: string = '210-111';

  public static readonly MOUNTINGRAILTYPE_DIN_99_TS: string = 'DIN_99_TS';
  public static readonly MOUNTINGRAILTYPE_DIN_35_TS: string = 'DIN_35_TS';
  public static readonly MOUNTINGRAILTYPE_DIN_15_TS: string = 'DIN_15_TS';
}
